import Colors from '@/constants/Colors';
import { font } from '@/shared/Activities/RealTimeActivity/Players/SortImagesActivity/sortImages.utils';
import styled from 'styled-components';

export const StyledQuestionControls = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 20px;
  box-shadow: ${Colors.boxShadow};
  background-color: white;
  padding: 5px 20px;

  .screen {
    font-weight: ${font.weightBold};
    color: ${Colors.primary};
    flex: 1;
  }

  .timer {
    flex: 1;
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 20px;
    color: ${Colors.primary};

    .time-left {
      font-size: 30px;
      font-weight: ${font.weightBold};
    }
  }

  .buttons {
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: flex-end;
  }
`;
